import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { startSession } from '../../services/auth';
import { useAuth } from '../../contexts/AuthContext';

const StartSession = () => {
  const { token, email } = useParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const initiateSession = async () => {
      if (!token || !email) {
        setError('Missing token or email parameter');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await startSession(email, token);
        console.log('Session started successfully:', response);
        setSuccess(true);
        
        // Refresh the user data to update auth context
        await refreshUser();
        
        // Redirect to home page after a short delay
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 1500);
      } catch (err) {
        console.error('Error starting session:', err);
        setError(err.errors?.token?.[0] || 'Invalid or expired session link. Please try again or request a new link.');
      } finally {
        setLoading(false);
      }
    };

    initiateSession();
  }, [token, email, navigate, refreshUser]);

  return (
    <Container className="py-5 text-center">
      <h2 className="mb-4">Starting Session</h2>
      
      {loading && (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Starting your session...</p>
        </div>
      )}
      
      {error && (
        <Alert variant="danger" className="my-4">
          <Alert.Heading>Session Error</Alert.Heading>
          <p>{error}</p>
          <hr />
          <p className="mb-0">
            Please try again or <a href="/login" className="alert-link">log in</a> with your credentials.
          </p>
        </Alert>
      )}
      
      {success && (
        <Alert variant="success" className="my-4">
          <Alert.Heading>Session Started!</Alert.Heading>
          <p>You have been successfully logged in.</p>
          <p>Redirecting you to the home page...</p>
        </Alert>
      )}
    </Container>
  );
};

export default StartSession;
